import { render, staticRenderFns } from "./PricesList.vue?vue&type=template&id=159a6d98"
import script from "./PricesList.vue?vue&type=script&lang=js"
export * from "./PricesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports